<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('readNoticeList.title')" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('readNoticeList.order')" prop="order">
          <el-input
            @input="
              (res) => {
                this.ruleForm.order = +res;
              }
            "
            @mousewheel.native.prevent  
            @DOMMouseScroll.native.prevent 
            type="number"
            placeholder="정렬순이 높은 건이 우선 노출됩니다."
            v-model="ruleForm.order"
          ></el-input>
        </el-form-item>
         <el-form-item :label="$t('readNoticeList.is_top')" prop="is_top">
          <el-radio-group size="medium" v-model="ruleForm.is_top">
            <el-radio :label="0">{{ $t("readNoticeList.is_top0") }}</el-radio>
            <el-radio :label="1">{{ $t("readNoticeList.is_top1") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('readNoticeList.active')" prop="active">
          <el-radio-group size="medium" v-model="ruleForm.active">
            <el-radio :label="0">{{ $t("readNoticeList.active0") }}</el-radio>
            <el-radio :label="1">{{ $t("readNoticeList.active1") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('readNoticeList.content')" prop="content">
          <div v-if="load">
            <SummerNote
              :id="'summernote' + new Date().getTime()"
              v-model="ruleForm.content"
            />
          </div>
        </el-form-item>
      </el-form>
      <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
        $t("btnTip.submit")
      }}</el-button>
    </el-card>
  </div>
</template>
<script>
import SummerNote from "@/components/summernote";
import { readNoticeDetail, addReadNotice, editReadNotice } from "@/api/api";
export default {
  name: "editRead",
  data() {
    return {
      ruleForm: {
        title: "",
        order: 0,
        active: "",
        is_top: 0,
        content: "",
        club: this.$route.params.readId,
      },
      rules: {
        title: [
          {
            required: true,
            message: this.$t("readNoticeList").title,
            trigger: "blur",
          },
        ],
        order: [
          {
            required: true,
            message: "정렬순이 높은 건이 우선 노출됩니다.",
            trigger: "blur",
          },
        ],
        is_top: [
          {
            required: true,
            message: this.$t("readNoticeList").is_top,
            trigger: "blur",
          },
        ],
        active: [
          {
            required: true,
            message: this.$t("readNoticeList").active,
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("readNoticeList").content,
            trigger: "blur",
          },
        ],
      },
      load: false,
    };
  },
  components: { SummerNote },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t("btnTip").add
        : this.$t("btnTip").edit;
    },
  },
  methods: {
    async submitForm(formName) {
      await this.$refs[formName].validate();
      if (this.id === undefined) {
        await addReadNotice(this.ruleForm);
      } else {
        delete this.ruleForm.create_time;
        delete this.ruleForm.publisher_name;
        delete this.ruleForm.type;
        await editReadNotice(this.ruleForm);
      }
      this.$router.go(-1);
    },
    async get_info() {
      const information = await readNoticeDetail(this.id);
      this.ruleForm = { ...information };
      this.load = true;
    },
  },
  async created() {
    if (this.id === undefined) {
      this.load = true;
      return;
    }
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
</style>
